import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Card, Spinner, Button, Table, Col, Row, Alert } from 'react-bootstrap';
import { FaEdit, FaTrash, FaPlus, FaArrowLeft } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { getAllReservationEmail, reservationEmailDeletion } from "./ReservationEmailAction";

import $ from 'jquery';
import Swal from "sweetalert2";
import { getSRolePermission } from '../userRolePermission/rolepermissionAction';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Button1 from '@mui/material/Button';


const ReservationEmailList = () => {
    
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const firstUpdate = useRef(true);
   
    const { reservationEmail, stisLoading,permissiondmessage,stdmessage,stcmessage } = useSelector((state) => state.reservationEmailsList);
   

    useEffect(() => {
        dispatch(getSRolePermission());
        
    }, []);

    const { permissionisLoading, combinedrolepermissiondetails } = useSelector(
        (state) => state.rolePermissionList
      );
      
      const filteredPermissions = combinedrolepermissiondetails.filter(
        (item) => item.label === "Reservation Email"
      );
      
      let menu_add = 0;
      let menu_edit = 0;
      let menu_delete = 0;
      
      if (filteredPermissions.length > 0) {
        const permission = filteredPermissions[0];
        menu_add = permission.menu_add;
        menu_edit = permission.menu_edit;
        menu_delete = permission.menu_delete;
      }

   
    useLayoutEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            dispatch(getAllReservationEmail());
            return;
        }

    });
    useEffect(() => {
        dispatch(getAllReservationEmail());
       
    }, [dispatch,stdmessage]);
    useEffect(() => {
        dispatch(getAllReservationEmail());
       
    }, [dispatch,stcmessage]);

    if (stisLoading) {
        return (
            <>
                <Container className="my-4 mx-4 container-xl justify-content-center">
                    <h2>Loading.....</h2>
                    {stisLoading && <Spinner variant='info' center="true" animation='border' />}

                </Container>
            </>
        );
    }

    if (reservationEmail.length === 0) {
        return (
            <>
                <Container className="my-4 mx-4 container-xl">
                <div class="card-header"  style={{marginTop:'-80px'}}>
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Reservation Email List</h3>
                        {/* {menu_add === 1 && (<div style={{ display: 'flex', justifyContent: 'flex-start' }}><Link className="btn alink btncolorb" variant="btncolorb" to="/createReservationEmail"><FaPlus className='fwcolor' /> Add Reservation Email</Link>{' '}</div>)} */}
                        {menu_add === 1 && (<Button1 variant="contained" onClick={() => navigate('/createReservationEmail')}  color="success" style={{ width: '', float: '', backgroundColor: '#d1af2b', fontSize: '10px'}} startIcon={<AddCircleOutlineIcon />}>
                        Add Reservation Email
                        </Button1>)}
                    </div>
                </Container>
                <div className="my-4 ms-3">
                    <div className="card">
                        <div className="card-body">
                            <div>
                                <Link to="/">
                                    <span className="badge bg-success" style={{ backgroundColor: 'rgb(156 186 237)', color: 'white' }}>
                                        <FaArrowLeft />&nbsp;Go Back
                                    </span>
                                </Link>
                            </div>
                            <br />
                            <div>
                                <table className="table table-hover table-bordered display" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                        <td colSpan="5" style={{ textAlign: 'center' }}>No data available</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }


    const renderedReservation = reservationEmail.map((reservations,index) => (
        <tr key={reservations.id}>
            <td>{index + 1}</td>
           
            <td>{reservations.reservation_email}</td>   
           
            <td>{reservations.status === 1 ? <span className="badge bg-success"> Enable</span> : <span className="badge bg-danger"> Disable</span>}</td>
            <td><>{menu_edit === 1 && ( <Button className="btn btn-sm btn-warning me-2"  onClick={(e) => onReservationEmailModify(reservations.id,e)} ><FaEdit className='fwcolor' /></Button>)}
            {menu_delete === 1 && (<Button className="btn btn-sm btn-danger me-2" onClick={(e) => onReservationEmailDelete(reservations.id, e)} ><FaTrash className='fwcolor' /></Button>)}</></td>
        </tr>
    ))

    const onReservationEmailDelete = (id, e) => {
        Swal.fire({
            title: 'Are you sure want to delete the Email?',
            showDenyButton: true,
            icon:'error',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            customClass: {
              actions: 'my-actions',
              cancelButton: 'order-1 right-gap',
              confirmButton: 'order-2',
              denyButton: 'order-3',
            }
          }).then((result) => {
            if (result.isConfirmed) {
                dispatch(reservationEmailDeletion(id)).then(() => {
                    dispatch(getAllReservationEmail()); 
                  Swal.fire('Reservation Email Deleted Successfully!', '', 'success');
                })
            }
                 else if (result.isDenied) {
                  Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
                }
              })
           
    
        }
    

    const onReservationEmailModify = (id, e) => {
         e.preventDefault();
        //console.log('select role '+id);
        navigate('/modifyReservationEmail/' + id); 
    }
    


    //initialize datatable
    $(document).ready(function () {
        setTimeout(function () {
            if ($.fn.dataTable.isDataTable('#example')) {
                const table = $('#example').DataTable();
            }
            else {
                const table = $('#example').DataTable({
                    paging: true,
                    pagingType: 'full_numbers',
                    pageLength: 5,
                     processing: true,
                     dom: 'Bfrtip',
                    // buttons: ['copy', 'csv', 'print'],
                    buttons: ['csv', 'print'],
                    destroy: true,

                });
            }

        },
            1000
        );
    });
    return (
        <>

            <div className="my-4  container-xl">
                <div class="card" style={{marginTop:'-80px'}}>
                    <div class="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Reservation Email List</h3>
                        {/* {menu_add === 1 && (<div style={{ display: 'flex', justifyContent: 'flex-start' }}><Link className="btn alink btncolorb" variant="btncolorb" to="/createReservationEmail"><FaPlus className='fwcolor' /> Add Reservation Email</Link>{' '}</div>)} */}
                        {menu_add === 1 && (<Button1 variant="contained" onClick={() => navigate('/createReservationEmail')}  color="success" style={{ width: '', float: '', backgroundColor: '#d1af2b', fontSize: '10px'}} startIcon={<AddCircleOutlineIcon />}>
                        Add Reservation Email
                        </Button1>)}
                    </div>
                    <div class="card-body">
                        <div>
                        <Link to="/"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
                        </div>
                        
                        <br />

                        {reservationEmail?.length
                            ? (
                                <table id="example" class="table table-hover table-bordered display" style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderedReservation}


                                    </tbody>
                                </table>
                            ) : <p>No Reservation Email to display</p>
                        }

                    </div>
                </div>
            </div>

        </>
    )
}

export default ReservationEmailList;


